import {
  ON_GET_INDIVIDUAL_USER,
  ADD_INDIVIDUAL_USER,
  INDIVIDUAL_USER_ERROR,
  GET_INDIVIDUAL_USERS,
  GET_INDIVIDUAL_USER,
} from "../../actions/types";

const initialState = {
  individualUsers: [],
  individualUser: null,
  loading: true,
  error: {},
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ON_GET_INDIVIDUAL_USER:
      return {
        ...state,
        loading: true,
      };
    case ADD_INDIVIDUAL_USER:
      return {
        ...state,
        individualUser: payload,
        loading: false,
      };
    case GET_INDIVIDUAL_USER:
      return {
        ...state,
        individualUser: payload,
        loading: false,
      };
    case GET_INDIVIDUAL_USERS:
      return {
        ...state,
        individualUsers: payload,
        loading: false,
      };
    case INDIVIDUAL_USER_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
